import { Component, inject } from "@angular/core";
import {
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from "@angular/forms";
import {
    Button,
    Checkbox,
    Icon,
    Input,
    Label,
    ModalContainer,
    ModalService,
} from "@malirang/front-share";

@Component({
    selector: "app-unmask-verification-modal",
    standalone: true,
    imports: [
        ReactiveFormsModule,
        Button,
        Checkbox,
        Input,
        Label,
        Icon,
        ModalContainer,
    ],
    template: `
        <section modalContainer>
            <div header class="flex gap-2 items-end p-6 pb-0">
                <div
                    class="text-xl font-bold text-red-600 flex gap-2 items-center"
                >
                    <app-icon
                        name="material-symbols:warning-rounded"
                        class="text-2xl"
                    />
                    <span>개인정보 마스킹 해제</span>
                </div>
            </div>

            <div class="flex flex-col gap-6 p-6 w-[32rem]">
                <div class="flex flex-col gap-2">
                    <p class="text-gray-600 break-keep">
                        개인정보 보호를 위해 마스킹이 적용되어 있습니다. 해제 시
                        화면에 노출된 개인정보에 대한 책임은 본인에게 있습니다.
                        마스킹을 해제하시겠습니까?
                    </p>
                </div>

                <form [formGroup]="form" class="flex flex-col gap-4">
                    <div class="flex flex-col gap-2">
                        <app-label [required]="true">해제 사유</app-label>
                        <textarea
                            class="p-3 w-full h-24 text-sm rounded-lg border border-gray-300 resize-none focus:outline-none focus:border-primary"
                            placeholder="마스킹 해제 사유를 입력해 주세요."
                            formControlName="reason"
                        ></textarea>
                    </div>

                    <div class="p-4 bg-red-50 rounded-lg border border-red-100">
                        <app-checkbox
                            formControlName="agreed"
                            label="개인정보 유출 시 민/형사상 책임은 본인에게
                                있음을 확인합니다."
                        />
                    </div>
                </form>
            </div>

            <div footer class="flex gap-3 justify-end p-6 pt-0">
                <app-button color="white" (click)="cancel()">취소</app-button>
                <app-button
                    color="red"
                    [disabled]="form.invalid"
                    (click)="confirm()"
                >
                    마스킹 해제
                </app-button>
            </div>
        </section>
    `,
})
export class UnmaskVerificationModal {
    private modalRef = inject(ModalService);

    form = new FormGroup({
        reason: new FormControl("", [
            Validators.required,
            Validators.minLength(2),
        ]),
        agreed: new FormControl(false, [Validators.requiredTrue]),
    });

    cancel() {
        this.modalRef.close();
    }

    confirm() {
        if (this.form.valid) {
            this.modalRef.close({
                confirmed: true,
                reason: this.form.value.reason,
            });
        }
    }
}
